import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import AdminLogin from '../components/admin/AdminLogin'
import AdminDashboard from '../components/admin/AdminDashboard'

const AdminPage: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('fga_admin_token')
      if (token) {
        setIsAuthenticated(true)
      }
      setIsLoading(false)
    }

    checkAuth()
  }, [])

  const handleLogout = () => {
    setIsAuthenticated(false)
    localStorage.removeItem('fga_admin_token')
    localStorage.removeItem('fga_admin_user')
  }

  if (isLoading) {
    return (
      <>
        <Helmet>
          <title>Admin | FGA Prestige</title>
          <meta name="description" content="FGA Prestige admin portal" />
        </Helmet>
        
        <main className="min-h-screen flex items-center justify-center bg-luxury-black-950">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-luxury-gold-500"></div>
            <p className="mt-2 text-luxury-cream-200">Loading...</p>
          </div>
        </main>
      </>
    )
  }

  return (
    <>
      <Helmet>
        <title>Admin Dashboard | FGA Prestige</title>
        <meta name="description" content="Content management system for FGA Prestige luxury fashion services." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <main className="min-h-screen">
        {isAuthenticated ? (
          <AdminDashboard />
        ) : (
          <AdminLogin />
        )}
      </main>
    </>
  )
}

export default AdminPage